import { getEnabledEvents } from './utils'

import { registerGtmSubscribers } from './subscribers/gtm'
import { registerInternalSubscribers } from './subscribers/internal'
import { registerInternal2Subscribers } from './subscribers/internal2'
import { registerWebengageSubscribers } from './subscribers/webengage'

import { ValidatedScripts } from '../third-party-scripts/response-data-validator'

let hasBootstrapped = false

export function bootstrapEventSubscribers(thirdPartyScriptData: ValidatedScripts) {
    if (hasBootstrapped) return

    if (thirdPartyScriptData.webengage?.enabled) {
        registerWebengageSubscribers()
    }

    if (thirdPartyScriptData.gtm?.enabled) {
        const gtmEnabledEvents = getEnabledEvents(thirdPartyScriptData.gtm.events)
        registerGtmSubscribers(gtmEnabledEvents)
    }

    if (thirdPartyScriptData.internal?.enabled) {
        const internalEnabledEvents = getEnabledEvents(thirdPartyScriptData.internal.events)
        registerInternalSubscribers(internalEnabledEvents)
    }

    // TODO: remove it after test phase passed (also remove any code for internal2)
    if (thirdPartyScriptData.internal2?.enabled) {
        const internal2EnabledEvents = getEnabledEvents(thirdPartyScriptData.internal2.events)
        registerInternal2Subscribers(internal2EnabledEvents)
    }

    hasBootstrapped = true
}
